function Authorize() {
  return <div>Authorizing...</div>
}

export default Authorize
